import { ThemeColors, ThemeSpaces } from '../../theme';

export const drawerBase = ({ width, token }) => ({
  '.ant-drawer-close': {
    position: 'absolute',
    marginRight: 0,
    padding: 0,
    top: ThemeSpaces.SPACE_SM,
    left: ThemeSpaces.SPACE_SM,
    right: 'initial',
  },

  '.CloseButton': {
    fontSize: token.fontSizeHeading4,

    '&, &:hover': {
      color: ThemeColors.COLOR_GREY3,
    },
  },

  '> .ant-drawer-content-wrapper': {
    borderTopLeftRadius: token.borderRadiusLG,
    borderBottomLeftRadius: token.borderRadiusLG,
    height: 'auto',

    [`@media (min-width: ${token.screenLGMin}px)`]: {
      width: `${width}px !important`,
    },
    [`@media (max-width: ${token.screenMDMax}px)`]: {
      width: '320px !important',
    },

    '> .ant-drawer-content': {
      backgroundColor: ThemeColors.COLOR_WHITE3,
      borderTopLeftRadius: token.borderRadiusLG,
      borderBottomLeftRadius: token.borderRadiusLG,
    },

    '.ant-drawer-body': {
      display: 'flex',
    },
  },
});
